import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M604-174q-33 0-56-23-24-24-24-57v-452q0-33 24-57 23-23 56-23h102q33 0 57 23 23 24 23 57v452q0 33-23 57-24 23-57 23H604Zm-350 0q-33 0-57-23-23-24-23-57v-452q0-33 23-57 24-23 57-23h102q33 0 56 23 24 24 24 57v452q0 33-24 57-23 23-56 23H254Zm350-80h102v-452H604v452Zm-350 0h102v-452H254v452Zm0-452v452-452Zm350 0v452-452Z"/>',
  f: '<path d="M628-174q-33 0-56-23-24-24-24-57v-452q0-33 24-57 23-23 56-23h55q33 0 56 23 23 24 23 57v452q0 33-23 57-23 23-56 23h-55Zm-351 0q-32 0-56-23-23-24-23-57v-452q0-33 23-57 24-23 56-23h55q33 0 57 23 23 24 23 57v452q0 33-24 57-23 23-56 23h-55Z"/>',
};

export default data;
